
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import { HOSTING_SKU, formatMoney, loadMarketplace, productImageUrl } from "@/data/MarketplaceSites";

@Component
export default class MarketplaceTemplates extends Vue {
  $message: any;
  hostingSku = HOSTING_SKU;
  items: any[] = [];
  loading = false;
  error = "";
  dialog = false;
  valid = true;
  saving = false;
  original: any = null;
  model: any = null;
  image: File | null = null;

  headers = [
    { text: "", value: "image", sortable: false, width: 112 },
    { text: "Название", value: "caption" },
    { text: "Артикул", value: "sku" },
    { text: "Цена", value: "price", align: "end" },
    { text: "Статус", value: "instanceStateId" },
    { text: "", value: "actions", sortable: false, align: "end" },
  ];

  breadcrumbs = [
    { text: "Главная", to: "/" },
    { text: "Маркетплейс сайтов", disabled: true },
    { text: "Шаблоны сайтов", disabled: true },
  ];

  required = (v: any) => (v !== null && v !== undefined && `${v}`.trim() !== "") || "Обязательное поле";
  priceRule = (v: any) => (Number(v) >= 1 && Number.isInteger(Number(v))) || "Целое число рублей, не меньше 1";

  money = formatMoney;
  imageUrl = productImageUrl;

  async created() {
    await this.load();
  }

  async load() {
    this.loading = true;
    this.error = "";
    try {
      this.items = await loadMarketplace("templates");
    } catch (e: any) {
      this.error = e?.response?.data?.message ?? "Не удалось загрузить шаблоны";
    } finally {
      this.loading = false;
    }
  }

  edit(item: any) {
    this.original = item;
    this.model = { ...item, price: Number(item.price), forSale: item.instanceStateId === 4 };
    this.image = null;
    this.dialog = true;
  }

  async save() {
    const m = this.model;
    const o = this.original;
    const changes: { fieldName: string; fieldValue: any }[] = [];
    if (m.caption.trim() !== o.caption) changes.push({ fieldName: "caption", fieldValue: m.caption.trim() });
    if ((m.description ?? "") !== (o.description ?? "")) changes.push({ fieldName: "description", fieldValue: m.description });
    if (Number(m.price) !== Number(o.price)) changes.push({ fieldName: "price", fieldValue: Number(m.price) });
    const state = m.forSale ? 4 : 5;
    if (state !== o.instanceStateId) changes.push({ fieldName: "instanceStateId", fieldValue: state });

    this.saving = true;
    try {
      // PATCH меняет только перечисленные поля (PUT затёр бы остальные — см. docs/CMS_API_USAGE_GUIDE.md)
      if (changes.length) {
        await axios.patch(`/manage/product/${o.id}`, changes);
      }
      if (this.image) {
        const form = new FormData();
        form.append("file", this.image);
        await axios.post(`/manage/product/${o.id}/upload/defaultImage`, form);
      }
      this.dialog = false;
      this.$message?.("Сохранено");
      await this.load();
    } catch (e: any) {
      this.$message?.(e?.response?.data?.message ?? "Не удалось сохранить", "error");
    } finally {
      this.saving = false;
    }
  }
}
